import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=1f65240b&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65240b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f65240b')) {
      api.createRecord('1f65240b', component.options)
    } else {
      api.reload('1f65240b', component.options)
    }
    module.hot.accept("./Success.vue?vue&type=template&id=1f65240b&scoped=true&", function () {
      api.rerender('1f65240b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/result/Success.vue"
export default component.exports